import React from 'react'
import MaterialSymbol from '../material-symbol'

const EventNote = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="event_note" {...props} />
))

EventNote.displayName = 'EventNote'

export default EventNote
